const editaPerfilInitialState = {
  estado: false,
  editarPaciente: {
    nombre: "",
    domicilio: "",
    telefono: "",
    codigo_postal: "",
    fecha_nacimiento: "",
    sexo: "",
    email: "",
    telefono_movil: "",
    idlocalidad: "",
    localidad_desc: "",
    cobertura: {
      OSInactiva: false,
      OSNoDaConsulta: false,
      OSNoDaEstudios: false,
      PlanInactivo: false,
      idCobertura: "",
      idCoberturaPlan: "",
      cobertura: "",
      plan: "",
      afiliado: "",
    },
  },
};

export default editaPerfilInitialState;
